import { render, staticRenderFns } from "./SampleCell.vue?vue&type=template&id=313c6ca0&"
import script from "./SampleCell.vue?vue&type=script&lang=js&"
export * from "./SampleCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports